export enum OccupancyEnum {
    OCCUPIED = "Occupied",
    OCCUPIED_NR = "Occupied-NR",
    ASSIGNED = "Assigned",
    NOT_OCCUPIED= "Not Occupied"
}